// import moment from "moment";
// import { CalendarDaysIcon, CalendarIcon } from "@heroicons/react/20/solid";
import { CalendarDaysIcon, MapPinIcon } from "@heroicons/react/20/solid";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import moment from "moment-timezone";
import _ from "lodash";
import React, { useState, useEffect } from "react";
import { Disclosure } from "@headlessui/react";
import * as ical2json from "ical2json";
import AgendaView from "./AgendaView";
// import parsedCalendar from "./CalendarData";
import Spinner from "./Spinner";

// let events = parsedCalendar.VCALENDAR[0].VEVENT;
// events = events.sort((a, b) => a.DTSTART.localeCompare(b.DTSTART));
// console.log(events);

function Header() {
  return (
    <div className="relative bg-indigo-800">
      <div className="absolute inset-0">
        <img
          className="h-full w-full object-cover"
          src="https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&&sat=-100"
          alt=""
        />
        <div
          className="absolute inset-0 bg-indigo-800 mix-blend-multiply"
          aria-hidden="true"
        />
      </div>
      <div className="relative mx-auto max-w-7xl py-12 px-4 sm:py-18 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
          Hackathon Schedule
        </h1>
        <p className="mt-6 max-w-3xl text-xl text-indigo-100">
          Mattis amet hendrerit dolor, quisque lorem pharetra. Pellentesque
          lacus nisi urna, arcu sociis eu. Orci vel lectus nisl eget eget ut
          consectetur. Sit justo viverra non adipisicing elit distinctio.
        </p>
      </div>
    </div>
  );
}

const Event = ({ event }) => (
  <div key={event.UID} className="pt-4">
    {/* <span className="text-indigo-700">
                {moment.tz(event.DTSTART, "America/New_York").format("LLLL")}
              </span> */}
    <Timespan event={event} />
    <div
      className="text-lg font-medium leading-6"
      style={{ fontSize: "1.3rem", fontWeight: "bold" }}
    >
      {event.SUMMARY}
    </div>
    {event.LOCATION && <div className="mt-2 text-sm ">{event.LOCATION}</div>}
    <div className="mt-2 text-base ">{event.DESCRIPTION}</div>
  </div>
);

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Timespan = ({ event }) => {
  const [time, setTime] = useState(moment());
  useEffect(() => {
    setInterval(() => setTime(moment()), 10000);
  }, []);

  const startTime = moment.tz(event.DTSTART, "America/New_York");
  const endTime = event.DTEND && moment.tz(event.DTEND, "America/New_York");
  // console.log(event.SUMMARY, endTime);

  return (
    <div
      style={
        {
          // fontFamily: "DM Mono",
          // fontWeight: "bold",
          // fontWeight: 500,
        }
      }
      className="space-x-2"
    >
      {/* font-bold */}
      {endTime && time.isBetween(startTime, endTime) && (
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-lg text-lg font-medium bg-orange-700 text-orange-100 capitalize animate-pulse">
          Happening now
        </span>
      )}
      <span className="text-lg">
        {startTime.format("LT")}
        {event.DTEND && <> - {endTime.format("LT")}</>} {startTime.format("z")}
      </span>
      {/* <br />
  <span className="">
    {moment.tz(event.DTSTART, "America/New_York").format("LL")}
  </span> */}
    </div>
  );
};

const ExpandableEvent = ({ event }) => (
  <div key={event.UID} className="pt-4">
    {/* <span className="text-indigo-700">
                {moment.tz(event.DTSTART, "America/New_York").format("LLLL")}
              </span> */}
    <Timespan event={event} />
    <Disclosure
      as="div"
      // key={faq.question}
      // className="pt-6"
      className="pt-2"
    >
      {({ open }) => (
        <>
          <dt
            // className="text-lg"
            className="text-lg font-medium leading-6"
            // style={{ fontSize: "1.3rem", fontWeight: "bold" }}
            style={{ fontSize: "1.3rem" }}
          >
            <Disclosure.Button className="flex w-full items-start justify-between text-left ">
              <span className="flex w-full items-baseline justify-between">
                <span className="">{event.SUMMARY}</span>
                {event.LOCATION && (
                  <span className="font-regular text-sm opacity-70">
                    <div className="flex items-center">
                      <MapPinIcon className="mr-1 h-4 w-4" aria-hidden="true" />
                      {event.LOCATION}
                    </div>
                  </span>
                )}
              </span>
              <span className="ml-6 flex h-7 items-center text-gray-400">
                <ChevronDownIcon
                  className={classNames(
                    open ? "-rotate-180" : "rotate-0",
                    "h-6 w-6 transform"
                  )}
                  aria-hidden="true"
                />
              </span>
            </Disclosure.Button>
          </dt>
          <Disclosure.Panel as="dd" className="mt-2 pr-12">
            {/* {event.LOCATION && (
              <div className="mt-2 text-sm ">
                <div className="flex items-center">
                  <MapPinIcon className="mr-1 h-4 w-4" aria-hidden="true" />
                  {event.LOCATION}
                </div>
              </div>
            )} */}
            {/* <p className="text-base" style={{ whiteSpace: "pre-line" }}>
              {event.DESCRIPTION || "No description"}
            </p> */}
            <p
              className="text-base"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: event.DESCRIPTION || "No description",
              }}
            />
            {/* {event.DESCRIPTION || "No description"}
            </p> */}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
    {/* <div
      className="text-lg font-medium leading-6"
      style={{ fontSize: "1.3rem", fontWeight: "bold" }}
    >
      {event.SUMMARY}
    </div>
    {event.LOCATION && <div className="mt-2 text-sm ">{event.LOCATION}</div>}
    <div className="mt-2 text-base ">{event.DESCRIPTION}</div> */}
  </div>
);

const parseText = (text) => {
  if (!text) return text;
  // console.log(text);
  text = text.replace(/<br>|\\n/g, "\n");
  text = text.replace(/\\|<\/*u>/g, "");
  text = text.replace(
    /<span style="background-color: var\(--textfield-surface\);">|<\/span>/g,
    ""
  );
  text = text.replace(/&nbsp;|<\/*html-blob>/g, " ");
  return text;
};

const App = ({ icalAddress }) => {
  // console.log(icalAddress);

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // const loadMoreCommit = () => {
  //   setPage(page + 1);
  // };

  useEffect(() => {
    const baseUrl = "https://hackathon-schedule-function.netlify.app";
    fetch(
      `${baseUrl}/get-schedule?icalAddress=${icalAddress}`,
      // `https://calendar.google.com/calendar/ical/pspji248492so7t97vg80j0ngo%40group.calendar.google.com/public/basic.ics`,
      {
        method: "GET",
        // headers: new Headers({
        //   Accept: "application/vnd.github.cloak-preview",
        // }),
      }
    )
      .then((res) => res.text())
      .then((response) => {
        let parsedCalendar = ical2json.convert(response);
        let parsedEvents = parsedCalendar.VCALENDAR[0].VEVENT;
        parsedEvents = parsedEvents.sort((a, b) =>
          a.DTSTART.localeCompare(b.DTSTART)
        );
        parsedEvents.forEach((event) => {
          event.LOCATION = parseText(event.LOCATION);
          event.SUMMARY = parseText(event.SUMMARY);
          event.DESCRIPTION = parseText(event.DESCRIPTION);
        });
        // console.log(parsedEvents);
        // setCommitHistory(response.items);
        // console.log(response);
        // var jcalData = ICAL.parse(iCalendarData);
        // console.log(jcalData);
        setLoading(false);
        setEvents(parsedEvents);
      })
      .catch((error) => console.log(error));
  }, []);

  let eventsByDay = _.groupBy(events, (event) =>
    moment.tz(event.DTSTART, "America/New_York").format("YYYY-MM-DD")
  );
  // console.log(eventsByDay);

  let days = Object.keys(eventsByDay).sort();
  // console.log(days);
  // let days = [
  //   "2016-05-25",
  //   "2016-05-26",
  //   // "2016-05-27"
  // ];

  // console.log(eventsByDay);
  return (
    <section
      className="mx-auto max-w-md divide-y-2 divide-blue-gray-200 py-12 px-4 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:py-24 lg:px-8"
      aria-labelledby="agenda-heading"
    >
      <div className="flex w-full items-baseline justify-between flex-wrap gap-y-4">
        <h2
          // font-bold
          className="text-3xl tracking-tight text-blue-gray-900 font-bold"
          id="agenda-heading"
        >
          Hackathon Agenda
        </h2>
        {icalAddress && (
          <a
            // type="button"
            className="inline-flex items-center rounded-md border border-transparent bg-yellow-600 px-3 py-2 text-md font-medium leading-4 text-white shadow-sm hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
            href={icalAddress
              .replace("/public/basic.ics", "")
              .replace("ical/", "u/0/r?cid=")
              .replace("%40", "@")}
            // href="https://calendar.google.com/calendar/u/0/r?cid=5769e06fdb10eb18dc1317482e073e7f823aa9a18b094a8604bdaf83ef113443@group.calendar.google.com"
            target="_blank"
          >
            <CalendarDaysIcon
              className="-ml-0.5 mr-2 h-4 w-4"
              aria-hidden="true"
            />
            Add to your Google Calendar
          </a>
        )}
      </div>

      <div className="mt-6 pt-10">
        {loading ? (
          <Spinner />
        ) : (
          <div
            className={`grid grid-cols-1 gap-y-20 ${
              {
                1: "lg:grid-cols-1",
                2: "lg:grid-cols-2",
                3: "lg:grid-cols-3",
                4: "lg:grid-cols-4",
                5: "lg:grid-cols-5",
                6: "lg:grid-cols-6",
                7: "lg:grid-cols-7",
                8: "lg:grid-cols-8",
                9: "lg:grid-cols-9",
                10: "lg:grid-cols-10",
              }[days.length]
            } lg:gap-y-0 lg:gap-x-8`}
            // className="grid grid-cols-1 gap-y-20 lg:grid-cols-2 lg:gap-y-0 lg:gap-x-8"
          >
            {days.map((day) => (
              <div className="divide-y-2 space-y-4" key={day}>
                {/* font-bold */}
                <div className="text-3xl tracking-tight text-blue-gray-900 ">
                  {/* sticky top-0 */}
                  {/* font-bold */}
                  <span className="text-2xl tracking-tight text-blue-gray-900">
                    {moment(day).format("dddd")}
                  </span>
                  <br />
                  {moment(day).format("LL")}
                </div>
                {eventsByDay[day].map((event) => (
                  <ExpandableEvent event={event} key={event.UID} />
                  // <div key={event.id}>
                  //   <dt className="text-lg font-medium text-blue-gray-900">
                  //     {event.question}
                  //   </dt>
                  //   <dd className="mt-2 text-base text-blue-gray-500">
                  //     {event.answer}
                  //   </dd>
                  // </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

function OldApp() {
  const [page, setPage] = useState(1);
  // const [commitHistory, setCommitHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // const loadMoreCommit = () => {
  //   setPage(page + 1);
  // };

  // useEffect(() => {
  //   fetch(
  //     `https://calendar.google.com/calendar/ical/pspji248492so7t97vg80j0ngo%40group.calendar.google.com/public/basic.ics`,
  //     {
  //       method: "GET",
  //       // headers: new Headers({
  //       //   Accept: "application/vnd.github.cloak-preview",
  //       // }),
  //     }
  //   )
  //     .then((res) => res.json())
  //     .then((response) => {
  //       // setCommitHistory(response.items);
  //       console.log(response);
  //       // var jcalData = ICAL.parse(iCalendarData);
  //       // console.log(jcalData);
  //       setIsLoading(false);
  //     })
  //     .catch((error) => console.log(error));
  // }, [page]);

  return (
    <div className="App">
      {/* <Header /> */}
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
      {/* <div className="mt-12 lg:col-span-2 lg:mt-0"> */}
      <div className="relative mx-auto mt-12 max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* <div className="mb-6">
          <a
            // type="button"
            className="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            href="https://calendar.google.com/calendar/ical/pspji248492so7t97vg80j0ngo%40group.calendar.google.com/public/basic.ics"
            target="_blank"
          >
            <CalendarDaysIcon
              className="-ml-0.5 mr-2 h-4 w-4"
              aria-hidden="true"
            />
            Add to your calendar
          </a>
        </div> */}
        <dl className="space-y-12">
          {/* {events.map((event) => ( */}
          {[].map((event) => (
            <div key={event.UID}>
              {/* <span className="text-indigo-700">
                {moment.tz(event.DTSTART, "America/New_York").format("LLLL")}
              </span> */}
              <div
                style={
                  {
                    // fontFamily: "DM Mono",
                    // fontWeight: "bold",
                    // fontWeight: 500,
                  }
                }
              >
                <span className="text-indigo-700">
                  {moment.tz(event.DTSTART, "America/New_York").format("LT")}
                  {event.DTEND && (
                    <>
                      {" "}
                      -{" "}
                      {moment.tz(event.DTEND, "America/New_York").format("LT")}
                    </>
                  )}{" "}
                  {moment.tz(event.DTSTART, "America/New_York").format("z")}
                </span>
                <br />
                <span className="text-indigo-700">
                  {moment.tz(event.DTSTART, "America/New_York").format("LL")}
                </span>
              </div>
              <div className="text-lg font-medium leading-6 text-gray-900">
                {event.SUMMARY}
              </div>
              {event.LOCATION && (
                <div className="mt-2 text-sm text-indigo-500">
                  {event.LOCATION}
                </div>
              )}
              <div className="mt-2 text-base text-gray-500">
                {event.DESCRIPTION}
              </div>
            </div>
          ))}
        </dl>
      </div>
      {/* <AgendaView /> */}
    </div>
  );
}

export default App;
// export default AgendaView;
